import { HorizontalAlignment, ModelRow } from "@mcleod/core";
import { AutogenLayoutAuditLog } from "./autogen/AutogenLayoutAuditLog";
import { Panel, Table, TableColumn, TableRowExpansionEvent, TableRowMode, ClickEvent, DataSource, Component, Textbox, Label, Checkbox, TableRow } from "@mcleod/components";
import { CommonDialogs } from "./CommonDialogs";

export class AuditLog extends AutogenLayoutAuditLog {

    public auditedDatasource:DataSource;

    /** This is an event handler for the onRowExpand event of tableAuditLog. */
    tableAuditLogOnRowExpand(event: TableRowExpansionEvent) {
        const tableRow: TableRow = event.target as TableRow;
        const data=tableRow.data.get("details");
        const expandPanel = event.expandComponentParent as Panel;
        expandPanel.addMountListener(()=> {
            const detailsTable: Table = expandPanel.findComponentById("tableDetails") as Table
            const rows: ModelRow[] = [];
            detailsTable.clearRows();
            for( const thisData of data){
                const row = new ModelRow(null);
                row.setValues({ field: thisData.field, old: thisData.oldValue, new: thisData.newValue});
                detailsTable.addRow(row, null, { display: true, addToData: false });
                console.log(row);
            }
        })
    }

    /** This is an event handler for the onDblClick event of tableAuditLog. */
    tableAuditLogOnDblClick(event: ClickEvent) {
        const data=this.tableAuditLog.selectedRow.data.get("details");
        const rows: ModelRow[] = [];
        for( const thisData of data){
            const row = new ModelRow(null);
            const fieldName=thisData[0];
            row.setValues({ field: fieldName, old: thisData[1], new: thisData[2]});
            rows.push(row)
        }

        const tableFields = new Table({ headerVisible: false, height: 220, padding: 0, rowBorderBottomWidth: 0, marginBottom: 12 })
        tableFields.addColumn(new TableColumn({ headingDef: { caption: "Field" }, cell: { field: "field" } }), true, false);
        tableFields.addColumn(new TableColumn({ headingDef: { caption: "Old value" }, cell: { field: "old" } }), false, false);
        tableFields.addColumn(new TableColumn({ headingDef: { caption: "New value" }, cell: { field: "new" } }), false, true);
        tableFields.displayData(rows[0], rows, 0);
        CommonDialogs.showDialog(tableFields, { title: "Changes" , width: 700, height: 300, resizable: true });
    }
}
